var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header',{staticClass:"header"}),_c('div',{class:{ 'container': !_vm.fullwidth, 'v-center': _vm.vCenter },attrs:{"id":"site-content"}},[_c('router-view')],1),_c('Footer',{staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }